import { Injector, InjectionToken, Provider } from '@angular/core';
import { Workflow } from './types/workflow';

export interface WorkflowSummaryCell {
  label: string;
  value: string | number | null;
  format?: 'text' | 'numeric' | 'id';
  sub?: string | null;
}

export interface WorkflowSummaryTable {
  title?: string;
  columns: string[];
  rows: string[][];
}

export interface WorkflowSummary {
  cells: WorkflowSummaryCell[];
  tables?: WorkflowSummaryTable[];
}

export interface WorkflowTypeConfig {
  type: string;
  getRoute: (workflow: Workflow) => string[];
  getSummary?: () => Promise<
    (workflow: Workflow, injector: Injector) => Promise<WorkflowSummary>
  >;
  getSummaryProviders?: () => Provider[];
  viewModes?: ('kanban' | 'table')[];
}

export const SOFTLINE_CONFIG_WORKFLOW_TYPE = new InjectionToken<WorkflowTypeConfig>(
  'SOFTLINE_CONFIG_WORKFLOW_TYPE'
);

export const WORKFLOW_TAB_VALUE = '__workflow__' as const;
export type WorkflowTabValue = typeof WORKFLOW_TAB_VALUE;
